import React from "react";
import Link from "gatsby-link";

class HighlightedReviews extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const data = this.props.data;

    return (
      <div className="HighlightedReviews">
        <div className="expertreviews">
          <h2>Word on the Street</h2>
          <div className="item">
            <div className="photo"><img src="https://www.datocms-assets.com/6493/1562011536-dani-drasin-profile-picture.jpg?w=140" alt="Dani Drasin" /></div>
            <div className="content">
              <p>"Would recommend to anyone who goes to yoga after work. I’m a teacher so I don’t have time to go to yoga in the morning (wake up at 4am? no thank you!!). So my only option is after work when all I want to do is lay down. That’s why I bought Yoga Flow. It’s a fantastic little pick me up that doesn’t leave you thirsty or mess with your stomach like coffee or espresso. You can get right into class because you’re more awake and less sluggish." <strong>Dani Drasin<em>@danidrasin</em></strong></p>
            </div>
          </div>
          <div className="item">
            <div className="photo"><img src="https://www.datocms-assets.com/6493/1562011533-linnea-jamtin-profile-picture.jpg?w=140" alt="Linnea Jamtin" /></div>
            <div className="content">
              <p>"I didn’t get what the big deal was about electrolytes and things like ayurvedic herbs until I tried Yoga Flow. This stuff really works! I used to get that dehydrated, kind of nauseous, dizzy feeling during my evening class but not anymore! Great buy" <strong>Linnea Jamtin<em>@linnea.jamtin</em></strong></p>
            </div>
          </div>
          <div className="item">
            <div className="photo"><img src="https://www.datocms-assets.com/6493/1562011538-kyle-armour-profile-picture.jpg?w=140" alt="Kyle Armour" /></div>
            <div className="content">
              <p>"I’m trying to be more committed to yoga (at least 3x a week) so I thought, what could help me on my mission? I asked two people from my class and they told me about Yoga Flow. Not gonna lie, I LOVE it. For me, it’s mostly bc of the cardamom and turmeric. Your body becomes lighter, more flexible and just more awake. If you want to stick to a yoga routine, this is for you."<strong>Kyle Armour<em>@kwarmour</em></strong></p>
            </div>
          </div>
          <div className="item">
            <div className="photo"><img src="https://www.datocms-assets.com/6493/1562011535-brooke-welty-profile-picture.jpg?w=140" alt="Brooke Welty" /></div>
            <div className="content">
              <p>"I started using Yoga Flow because I’m not one of those people who can just go to yoga at any time. But Yoga Flow wakes me up, tastes great and keeps me hydrated so I don’t lose steam. Now I’m obsessed! Would definitely recommend for anyone who finds getting to yoga class to be a struggle."<strong>Brooke Welty<em>@brooke.welty.9</em></strong></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HighlightedReviews;


// WEBPACK FOOTER //
// ./src/buy/highlighted-reviews.js